module.exports = __webpack_public_path__ + "static/biancaWallpaper5-ebe1042cd1704424def79da458e101e1.jpg";